import React from "react";
import { AcceptHosted } from "../../common/payment-config-form/AcceptHosted";
import Fetch from "../../common/payment-config-form/Fetch";
import useTrafficPayment from "./useTrafficPayment";

const PaymentForm = ({ ...props }) => {
  const { authorizeSandbox } = useTrafficPayment();
  return <Fetch amount={props.amount} paymentType={props?.paymentType}>{(response) => <AcceptHosted type={"iframe"} mode={!authorizeSandbox ? "production" : "sandbox"} formToken={response} amount={props.amount} />}</Fetch>;
};

export default PaymentForm;
